import { createSelector } from '@ngrx/store';
import { State } from '../reducers';

export const selectItineraryState = (state: State) => state.itinerary;

// next deadline date
export const getItineraryList = createSelector(
    selectItineraryState,
    itinerary => itinerary.itineraryList
);